// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desc-text[data-v-5c4c0eb3] {\n    color: var(--danger) !important;\n}\n", ""]);
// Exports
module.exports = exports;
